import React, { useState } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import About from "./components/About";
import LoginModal from "./components/LoginModal";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardHome from "./pages/DashboardHome";
import ContentPage from "./pages/ContentPage";
import UserManagement from "./pages/UserManagement";
import SettingsPage from "./pages/SettingsPage";

function App() {
	const [showLoginModal, setShowLoginModal] = useState(false);

	return (
		<AuthProvider>
			<Router>
				<Routes>
					{/* Public Routes */}
					<Route
						path="/"
						element={
							<div className="min-h-screen bg-black">
								<Header onLoginClick={() => setShowLoginModal(true)} />
								<Hero />
								<LoginModal
									isOpen={showLoginModal}
									onClose={() => setShowLoginModal(false)}
								/>
							</div>
						}
					/>
					<Route
						path="/projects"
						element={
							<div className="min-h-screen bg-black">
								<Header onLoginClick={() => setShowLoginModal(true)} />
								<Projects />
								<LoginModal
									isOpen={showLoginModal}
									onClose={() => setShowLoginModal(false)}
								/>
							</div>
						}
					/>
					<Route
						path="/about"
						element={
							<div className="min-h-screen bg-black">
								<Header onLoginClick={() => setShowLoginModal(true)} />
								<About />
								<LoginModal
									isOpen={showLoginModal}
									onClose={() => setShowLoginModal(false)}
								/>
							</div>
						}
					/>

					{/* Protected Dashboard Routes */}
					<Route
						path="/dashboard"
						element={
							<ProtectedRoute>
								<Dashboard>
									<DashboardHome />
								</Dashboard>
							</ProtectedRoute>
						}
					/>
					<Route
						path="/dashboard/content"
						element={
							<ProtectedRoute>
								<Dashboard>
									<ContentPage />
								</Dashboard>
							</ProtectedRoute>
						}
					/>
					<Route
						path="/dashboard/users"
						element={
							<ProtectedRoute adminOnly={true}>
								<Dashboard>
									<UserManagement />
								</Dashboard>
							</ProtectedRoute>
						}
					/>
					<Route
						path="/dashboard/settings"
						element={
							<ProtectedRoute>
								<Dashboard>
									<SettingsPage />
								</Dashboard>
							</ProtectedRoute>
						}
					/>

					{/* Catch all */}
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</Router>
		</AuthProvider>
	);
}

export default App;
